<template>
<v-container fill-height fluid>
	<Preloader v-if="loading" text="Please wait..." />
	<v-col cols="12" justify="center" align="center"
		v-if="linkExpired && !loading">
		<p class="text-center mb-n1">
			This exam has been completed!
		</p>
		<p class="text-center">
			Check your email for your results. Thanks!
		</p>
	</v-col>
	<v-col cols="12" justify="center" align="center"
		v-else-if="!started && !loading">
		<p class="text-center mb-n1">
			You must complete the entrance examination within the time limit.
		</p>
		
		<p class="text-center">
			Good luck and God bless!
		</p>

		<v-btn
			color="primary"
			@click="start()">
			Start Examination
		</v-btn>
	</v-col>
	
	<Question
		v-if="started && !loading"
		:question="questions[currentIndex]"
		:current-index="currentIndex"
		:exam-length="questions.length"
		@prev="prevHandler"
		@next="nextHandler"
		@submit="submitHandler"
		/>	
</v-container>
  
</template>

<script>
import Preloader from '../main/Preloader'
import Question from '../question/Question'
import ExamMixin from '../../mixins/exam.mixin'
import Api from '../../services/api'

export default {
  name: 'ExamForm',
  components: { Preloader, Question },
	mixins: [ ExamMixin ],
	
  data() {
    return {
			started: false,
			linkExpired: false,
			questions: [],
			currentIndex: null,
			loading: false
    }
	},
	created() {
		let hashId = this.$route.params.hashId;
		if(hashId) {
			this.getExamData(hashId);
		} else {
			this.linkExpired = true;
		}
	},
  methods: {
		getExamData(hashId) {
			this.loading = true;

			Api.exam.get(hashId).then((response) => {
				this.exam = response.data;
				this.loading = false;
			})
			.catch(() => {
				this.loading = false;
				this.linkExpired = true;
			});
			
	
		},

		getAnswerData(examHashId) {
			let promise = new Promise((resolve) => {
				Api.exam.userAnswer(examHashId).then((response) => {
					let answers = response.data;
					for(let i=0; i<answers.length; i++) {
						for(let j=0; j<this.questions.length; j++) {
							if(answers[i].questionId == this.questions[j].id) {
								this.questions[j].userAnswer = answers[i].answer;
								break;
							}
						}
					}
					resolve();
				});
			});
			return promise;
		},
		
    prevHandler() {
			this.saveAnswer();
			if(this.currentIndex > 0) {
				this.currentIndex--;
			}
		},

    nextHandler() {
			this.saveAnswer();
			if(this.currentIndex < this.questions.length - 1) {
				this.currentIndex++;
			}
    },

		submitHandler() {
			this.loading = true;
			this.saveAnswer()
				.then(() => {
					Api.exam.submitAnswers(this.exam.hashId)
						.then((response) => {
							console.log(response);
							history.go();
						});
				});
		},

		saveAnswer() {
			let promise = new Promise((resolve) => {
				let examAnswer = {
					examHashId: this.exam.hashId,
					examId: this.exam.id,
					questionId: this.questions[this.currentIndex].id,
					answer: this.questions[this.currentIndex].userAnswer
				};
				if(examAnswer.answer) {
					Api.exam.saveAnswer(examAnswer).then(() => {
						resolve();
					})
					.catch(() => {
						history.go();
					});
				} else {
					resolve();
				}

			});

			return promise;

		},

    start() {
			this.loading = true;
			Api.question.getFromSet(1) // SET A questionnaire
				.then((response) => {
					let questions = response.data;
					this.questions = this.choicesToArray(questions);
					this.getAnswerData(this.exam.hashId)
						.then(() => {
							Api.exam.startExam(this.exam.hashId)
								.then((response) => {
									this.loading = false;
									this.started = true;
									this.currentIndex = 0;
									let timeDiff = response.data;
									this.$root.$emit('time-started', timeDiff);
									console.log(this.$root);
								});
						});

				});
			
		},

  }
}

</script>